module.exports = __webpack_public_path__ + "81b1766d246901ea99931e353f3a89b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/ui/assets/images/icons/ireland_icon.png
// module id = 1224
// module chunks = 0